import { useState } from 'react';

/**
 * Round avatar with initial-letter fallback. `src` should be our MIRRORED copy
 * (profile_pic_mirrored_url / avatar_url) — never a raw IG CDN link (those
 * expire in days). On missing/broken src renders the first letter of `name`
 * on a deterministic gradient so rows stay scannable.
 */
const PALETTE = [
  ['#4a9eff', '#2f6fe0'], ['#9B5DE5', '#6f3ec2'], ['#2ecc71', '#1d9e54'],
  ['#f1c40f', '#c79a06'], ['#e67e22', '#c05f0e'], ['#e74c3c', '#b93225'],
];

export function Avatar({ src, name, size = 28 }: { src?: string | null; name: string; size?: number }) {
  const [broken, setBroken] = useState(false);
  const letter = (name || '?').replace(/^@/, '').charAt(0).toUpperCase() || '?';
  const [c1, c2] = PALETTE[(name || '?').split('').reduce((a, ch) => a + ch.charCodeAt(0), 0) % PALETTE.length];
  const base: React.CSSProperties = {
    width: size, height: size, borderRadius: '50%', flex: 'none',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    verticalAlign: 'middle', overflow: 'hidden',
  };
  if (!src || broken) {
    return (
      <span style={{ ...base, background: `linear-gradient(135deg, ${c1}, ${c2})`,
                     color: '#fff', fontSize: size * 0.44, fontWeight: 600, userSelect: 'none' }}>
        {letter}
      </span>
    );
  }
  return (
    <img src={src} alt="" loading="lazy" onError={() => setBroken(true)}
         style={{ ...base, objectFit: 'cover' }} />
  );
}

export default Avatar;
